import { CreateBookingType } from "../../config/params";

export const actionTypes = {
  SET_BOOKING_APPOINTMENT_TYPE: "SET_BOOKING_APPOINTMENT_TYPE",
  SET_APPOINTMENT_TYPE_INDICATOR: "SET_APPOINTMENT_TYPE_INDICATOR",
  SET_DEFAULT_BOOKING_TYPE: "SET_DEFAULT_BOOKING_TYPE",
  SET_IS_DROPOFF_AVAILABLE: "SET_IS_DROPOFF_AVAILABLE",
  SET_IS_SERVICE_STATUS_UPDATED: "SET_IS_SERVICE_STATUS_UPDATED",
};

const setBookingAppointmentType = (payload: CreateBookingType) => ({
  type: actionTypes.SET_BOOKING_APPOINTMENT_TYPE,
  payload,
});

const setAppointmentTypeIndicator = (payload: Number) => ({
  type: actionTypes.SET_APPOINTMENT_TYPE_INDICATOR,
  payload,
});

const setDefaultBookingType = () => ({
  type: actionTypes.SET_DEFAULT_BOOKING_TYPE,
});

const setIsDropoffAvailable = (payload: Boolean) => ({
  type: actionTypes.SET_IS_DROPOFF_AVAILABLE,
  payload,
});

const setIsServiceStatusUpdated = (payload: Boolean) => ({
  type: actionTypes.SET_IS_SERVICE_STATUS_UPDATED,
  payload,
});

export default {
  setBookingAppointmentType,
  setAppointmentTypeIndicator,
  setDefaultBookingType,
  setIsDropoffAvailable,
  setIsServiceStatusUpdated,
};

